import React from 'react'

export default function Footer() {
   return (
      <footer className='glass footer d-flex'>
         <a href='https://yosefus-portfolio.netlify.app/' target="_blank" rel="noreferrer">
            all right reserved to YOSEFUS FLAVIUS
         </a>
      </footer>
   )
}
